import React from 'react';
import styled from 'styled-components';
import ImageGallery from 'react-image-gallery';
import playButton from '../../assets/images/play.png';
import 'react-image-gallery/styles/scss/image-gallery.scss';
import './Gallary.css';

const PREFIX_URL =
  'https://raw.githubusercontent.com/xiaolin/react-image-gallery/master/static/';

// style component for button //
const theme = {
  blue: {
    default: '#3f51b5',
    hover: '#283593',
  },
  pink: {
    default: '#e91e63',
    hover: '#ad1457',
  },
  green: {
    default: '#5eead4',
    hover: '#5eead433',
  }
};

const Button = styled.button`
  background-color: ${(props) => theme[props.theme].default};
  color: black;
  padding: 5px 15px;
  border-radius: 5px;
  outline: 0;
  border: 0; 
  text-transform: uppercase;
  margin: 10px 0px;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

Button.defaultProps = {
  theme: 'green',
};
// end: style component for button //


class Gallary extends React.Component {
  constructor() {
    super();
    this.state = {
      showIndex: false,
      showBullets: true,
      infinite: true,
      showThumbnails: true,
      showFullscreenButton: true,
      showGalleryFullscreenButton: true,
      showPlayButton: true,
      showGalleryPlayButton: true,
      showNav: true,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 2000,
      slideOnThumbnailOver: false,
      thumbnailPosition: 'bottom',
      showVideo: {},
      useWindowKeyDown: true,
    };
  }

  _onImageClick(event) {
    console.debug(
      'clicked on image',
      event.target,
      'at index',
      this._imageGallery.getCurrentIndex()
    );
  }

  _onImageLoad(event) {
    console.debug('loaded image', event.target.src);
  }

  _onSlide(index) {
    this._resetVideo();
    console.debug('slid to index', index);
  }

  _onPause(index) {
    console.debug('paused on index', index);
  }

  _onScreenChange(fullScreenElement) {
    console.debug('isFullScreen?', !!fullScreenElement);
  }

  _onPlay(index) {
    console.debug('playing from index', index);
  }

  _handleInputChange(state, event) {
    if (event.target.value > 0) {
      this.setState({ [state]: event.target.value });
    }
  }

  _handleCheckboxChange(state, event) {
    this.setState({ [state]: event.target.checked });
  }

  _handleThumbnailPositionChange(event) {
    this.setState({ thumbnailPosition: event.target.value });
  }

  _resetVideo() {
    this.setState({ showVideo: {} });

    if (this.state.showPlayButton) {
      this.setState({ showGalleryPlayButton: true });
    }

    if (this.state.showFullscreenButton) {
      this.setState({ showGalleryFullscreenButton: true });
    }
  }

  _toggleShowVideo = (url) => {
    this.setState((prevState) => ({
      showVideo: {
        ...prevState.showVideo,
        [url]: !prevState.showVideo[url],
      },
      showGalleryPlayButton: !prevState.showVideo[url] ? false : prevState.showGalleryPlayButton,
      showGalleryFullscreenButton: !prevState.showVideo[url] ? false : prevState.showGalleryFullscreenButton,
    }));
  }

  _renderVideo = (item) => {
    return (
      <div>
        {this.state.showVideo[item.embedUrl] ? (
          <div className="video-wrapper">
            <a
              className="close-video"
              onClick={() => this._toggleShowVideo(item.embedUrl)}
            />
            <div class="responsive-iframe-container">
              <iframe
                title={`video-${item.index}`}
                src={item.embedUrl}
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </div>
        ) : (
          <a onClick={() => this._toggleShowVideo(item.embedUrl)}>
            <div className="play-button">
              <img className="playButton" src={playButton}/>
            </div>
            <img className="image-gallery-image" src={item.original} alt="video thumbnail"/>
            {item.description && (
              <span
                className="image-gallery-description"
                style={{ right: '0', left: 'initial' }}
              >
                {item.description}
              </span>
            )}
          </a>
        )}
      </div>
    );
  }
  
  render() {
    // Map over the items array to add the new attribute
    const modifiedItems = this.props.items.map(item => ({
      ...item,
      renderItem: item.embedUrl? this._renderVideo: undefined,
    }));

    let galleryContext = this.props.items.length > 0 ? (
      <div id="gallary-page">
        <div className="gallary-box">
          <ImageGallery
            ref={(i) => (this._imageGallery = i)}
            items={modifiedItems}
            onClick={this._onImageClick.bind(this)}
            onImageLoad={this._onImageLoad}
            onSlide={this._onSlide.bind(this)}
            onPause={this._onPause.bind(this)}
            onScreenChange={this._onScreenChange.bind(this)}
            onPlay={this._onPlay.bind(this)}
            infinite={this.state.infinite}
            showBullets={this.state.showBullets}
            showFullscreenButton={
              this.state.showFullscreenButton &&
              this.state.showGalleryFullscreenButton
            }
            showPlayButton={
              this.state.showPlayButton && this.state.showGalleryPlayButton
            }
            showThumbnails={this.state.showThumbnails}
            showIndex={this.state.showIndex}
            showNav={this.state.showNav}
            isRTL={this.state.isRTL}
            thumbnailPosition={this.state.thumbnailPosition}
            slideDuration={parseInt(this.state.slideDuration)}
            slideInterval={parseInt(this.state.slideInterval)}
            slideOnThumbnailOver={this.state.slideOnThumbnailOver}
            additionalClass="app-image-gallery"
            useWindowKeyDown={this.state.useWindowKeyDown}
          />
          
          <div className="close-gallary-button-box">
            <Button onClick={() => this.props.updateModalStatus(false)}>
              close
            </Button>
          </div>
        </div>
      </div> 
    ) : null

    return (
      <>
        {galleryContext}
      </>
    );
  }
}

export default Gallary;
